import { render, staticRenderFns } from "./unreadNotifications.vue?vue&type=template&id=2ec2716c"
import script from "./unreadNotifications.vue?vue&type=script&lang=js"
export * from "./unreadNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec2716c')) {
      api.createRecord('2ec2716c', component.options)
    } else {
      api.reload('2ec2716c', component.options)
    }
    module.hot.accept("./unreadNotifications.vue?vue&type=template&id=2ec2716c", function () {
      api.rerender('2ec2716c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/topbar/unreadNotifications.vue"
export default component.exports